const positiveNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
};

export const findProductSize = (product, color, size) => {
  const variants = Array.isArray(product?.variants) ? product.variants : [];
  const variant = variants.find((item) => String(item?.color || "") === String(color || ""));
  const sizes = Array.isArray(variant?.tallas) ? variant.tallas : Array.isArray(variant?.sizes) ? variant.sizes : [];
  return sizes.find((item) => String(item?.size || "") === String(size || "")) || null;
};

export const resolveProductPricing = (product, color, size) => {
  const selected = findProductSize(product, color, size);
  const selectedHasPrice = selected && Object.prototype.hasOwnProperty.call(selected, "price_cop");
  const selectedHasOldPrice = selected && Object.prototype.hasOwnProperty.call(selected, "oldPrice");
  const price = positiveNumber(selectedHasPrice ? selected.price_cop : product?.price_cop) || 0;
  const oldPrice = positiveNumber(selectedHasOldPrice ? selected.oldPrice : product?.oldPrice);
  const hasDiscount = oldPrice !== null && oldPrice > price && price > 0;
  const savings = hasDiscount ? oldPrice - price : 0;
  return {
    price,
    oldPrice,
    hasDiscount,
    savings,
    percentage: hasDiscount ? Math.round((savings / oldPrice) * 100) : 0,
    selectedSize: selected,
  };
};

export const resolveProductCardPricing = (product) => {
  const variants = Array.isArray(product?.variants) ? product.variants : [];
  const availablePrices = variants
    .filter((variant) => variant?.active !== false)
    .flatMap((variant) => (
      Array.isArray(variant?.tallas)
        ? variant.tallas
        : Array.isArray(variant?.sizes)
          ? variant.sizes
          : []
    ))
    .filter((size) => size?.active !== false && Number(size?.stock) > 0)
    .map((size) => positiveNumber(Object.prototype.hasOwnProperty.call(size, "price_cop") ? size.price_cop : product?.price_cop))
    .filter((price) => price !== null);

  if (availablePrices.length) {
    const uniquePrices = [...new Set(availablePrices)];
    return {
      price: Math.min(...availablePrices),
      showFrom: uniquePrices.length > 1,
      source: "variant",
    };
  }

  return {
    price: positiveNumber(product?.price_cop),
    showFrom: false,
    source: "general",
  };
};
